import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m3.828 5 2.95-2.95L5.364.636 0 6l5.364 5.364L6.778 9.95 3.828 7H12V5H3.828Z" })
});
export default SvgArrowLeft;
